/**
 * Names shared across four files. Change them together or not at all
 * (tickets/16726-accessibility-widget.md §5, "Cross-file contract"):
 *
 *   - AccessibilityWidgetEmbed.java: emits the host element and the inline
 *     <head> snippet that sets the attributes before first paint
 *   - css/main.css: every page rule is keyed off an ATTR_PREFIX attribute and
 *     excludes HOST_ID
 *   - this bundle
 */

/** localStorage key. One JSON object per origin. */
export const STORAGE_KEY = 'edlio-a11y-prefs';

/** Stored-format version, so a future shape change can migrate or reset. */
export const STORAGE_VERSION = 1;

/** Prefix of the attributes set on <html> (`data-ea11y-spacing`, ...). */
export const ATTR_PREFIX = 'data-ea11y-';

/**
 * The host element the server emits at the end of <body>. A plain <div>, not
 * a custom element: the shared modern-ui Babel config compiles classes to ES5,
 * and an ES5 "class" cannot extend HTMLElement.
 */
export const HOST_ID = 'edlio-a11y-widget';

/** Attributes the server puts on the host. All already validated server-side. */
export const HOST_ATTR = {
  position: 'data-position',
  color: 'data-color',
  statementUrl: 'data-statement-url',
} as const;

/**
 * `<script type="application/json" id="…">` the server emits before the host
 * when the school uses the statement Edlio writes for them. Holds
 * `{"text": "…"}`, already filled in (AccessibilityWidgetStatement.render).
 * When it is present the statement opens in a dialog instead of a link.
 */
export const STATEMENT_ID = 'edlio-a11y-statement';

/**
 * The public chatbot's mount point and the two attributes footer.jsp puts on
 * it. Not ours: read-only, so the launcher can sit next to the chatbot's when
 * both are in the same corner. Shape is the chatbot client's
 * (public-websearch-chatbot-client/react/hooks/useChatbotConfig.ts):
 * configuration.payload.clientSettings.position, compared with
 * customTypes.payload.enums.ChatbotPositionEnum.BottomLeft.
 */
export const CHATBOT = {
  rootId: 'react-app-root',
  configAttr: 'data-chatbot-configuration',
  typesAttr: 'data-chatbot-custom-types',
  /** ChatbotPosition.BottomLeft, when the enum is not in the page. */
  bottomLeft: 1,
  /** Its launcher: 64px square, 16px from the side, 72px up below 768px wide, 16px above. */
  size: 64,
  inset: 16,
  bottomNarrow: 72,
  bottomWide: 16,
  wideQuery: '(min-width: 768px)',
} as const;
